import * as React from 'react';
import { DropdownItem } from 'reactstrap';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { NavLink as Link } from 'react-router-dom';
import { NavDropdown } from '../header-components';

export const EntitiesMenu = props => (
  // tslint:disable-next-line:jsx-self-close
  <NavDropdown icon="th-list" name="Entities" id="entity-menu">
    <DropdownItem tag={Link} to="/entity/sport">
      <FontAwesomeIcon icon="asterisk" />&nbsp; Sport
    </DropdownItem>
    <DropdownItem tag={Link} to="/entity/book">
      <FontAwesomeIcon icon="asterisk" />&nbsp; Book
    </DropdownItem>
    <DropdownItem tag={Link} to="/entity/book-subscription">
      <FontAwesomeIcon icon="asterisk" />&nbsp; Book Subscription
    </DropdownItem>
    {/* jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here */}
  </NavDropdown>
);
